import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KbCompareComponent } from './kb-compare.component';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbAddToCartModule } from '../../kb-add-to-cart/kb-add-to-cart.module';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [KbCompareComponent],
  imports: [
    CommonModule,
    I18nModule,
    KbAddToCartModule,
    RouterModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KbCompareFlexComponent: {
          component: KbCompareComponent,
          guards: [SecureGuard]
        },
      }
    } as CmsConfig)
  ]
})
export class CompareModule { }
